(function () {
'use strict';

a3_cabin_reports.service("SWUpdateService", SWUpdateService);

/**
* @memberof CabinReports
* @ngdoc service
* @name SWUpdateService
* @description 
*  manages the service-worker update
* @ngInject
*/
function SWUpdateService(LogService) {
    /**
     * initialize service worker
     * @memberof SWUpdateService
     */
    function initialize() {
        // Delay registration until after the page has loaded
        window.addEventListener('load', function () {
            //kill switch. uncomment this and comment out everything else sw related
            // navigator.serviceWorker.getRegistrations().then(function (registrations) {
            //     //returns installed service workers
            //     if (registrations.length) {
            //       for(var registration of registrations) {
            //         registration.unregister();
            //       }
            //     }
            // });

            //register the service worker and work with the promise it returns
            navigator.serviceWorker.register('service-worker.js').then(function (reg) {
                // use a variable to make sure we refresh the page only once
                var refreshing;

                //fires when a new Service Worker takes control of the current page (refreshes the page)
                navigator.serviceWorker.addEventListener('controllerchange', function () {
                    if (refreshing) return;
                    refreshing = true;
                    window.location.reload();
                });
            }).catch(function (e) {
                LogService.error(e, 'Tried to register the service worker');
            });
        });
    }

    /**
     * poll the server for new service worker file (new app version)
     * @memberof SWUpdateService
     */ 
    function checkUpdates(reg) {
        if (reg == null)
            return;
        
        //ask server for new service worker
        reg.update();
    }

    /**
     * If new service worker has been waiting too long, force update
     * @memberof SWUpdateService
     */
    function checkVersionExpiration(reg) {
        if (reg == null)
            return;
        reg.waiting.postMessage('checkVersionExpiration');
    }

    /**
     * Activate the new service worker that was waiting
     * @memberof SWUpdateService
     */
    function update(reg){
        reg.waiting.postMessage('skipWaiting');
    }

    return {
        initialize: initialize,
        checkUpdates: checkUpdates,
        checkVersionExpiration: checkVersionExpiration,
        update: update
    };
}

})();